import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BillPaymentResult,
  BillPaymentPayload,
} from "features/bbps/biller/billerFlowTypes";
import { NormalizedError } from "services/axios.services/interceptors/commonInterceptors";

export interface BillPaymentState {
  loading: boolean;
  data?: BillPaymentResult;
  error?: NormalizedError | null;
}

const initialState: BillPaymentState = {
  loading: false,
  data: undefined,
  error: null,
};

const billPaymentSlice = createSlice({
  name: "billPayment",
  initialState,
  reducers: {
    billPaymentRequested(state, _action: PayloadAction<BillPaymentPayload>) {
      state.loading = true;
      state.error = null;
    },
    billPaymentSucceeded(state, action: PayloadAction<BillPaymentResult>) {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    billPaymentFailed(state, action: PayloadAction<NormalizedError>) {
      state.loading = false;
      state.error = action.payload;
    },
    billPaymentReset() {
      return initialState;
    },
  },
});

export const {
  billPaymentRequested,
  billPaymentSucceeded,
  billPaymentFailed,
  billPaymentReset,
} = billPaymentSlice.actions;

export default billPaymentSlice.reducer;
